/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Loading_LabelInputs */

const en_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading indicator`)
};

const fr_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicateur de chargement`)
};

const de_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladeanzeige`)
};

const it_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicatore di caricamento`)
};

const ru_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Индикатор загрузки`)
};

const es_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicador de carga`)
};

const zh_cn2_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载指示器`)
};

const ja_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込みインジケーター`)
};

const hi_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोडिंग संकेतक`)
};

const pt_pt2_spellcheck_loading_label = /** @type {(inputs: Spellcheck_Loading_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicador de carregamento`)
};

/**
* | output |
* | --- |
* | "Loading indicator" |
*
* @param {Spellcheck_Loading_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_loading_label = /** @type {((inputs?: Spellcheck_Loading_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Loading_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_loading_label(inputs)
	if (locale === "de") return de_spellcheck_loading_label(inputs)
	if (locale === "it") return it_spellcheck_loading_label(inputs)
	if (locale === "ru") return ru_spellcheck_loading_label(inputs)
	if (locale === "es") return es_spellcheck_loading_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_loading_label(inputs)
	if (locale === "ja") return ja_spellcheck_loading_label(inputs)
	if (locale === "hi") return hi_spellcheck_loading_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_loading_label(inputs)
	return en_spellcheck_loading_label(inputs)
});